exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media print {\n.btn {\n    display: none;\n}\n}\n", ""]);

// exports
